import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-switch-lang';
import { observer } from 'mobx-react';
import chatStorage from './chatStorage';

class ConversationsHeader extends Component {
  render() {
    const { t } = this.props;
    return (
      <div className="search-container flex-row justify-content-between">
        <div className="input-search">
          <input type="text" placeholder={t('Search user')} value={chatStorage.searchUserString} onInput={(e) => chatStorage.changeSearchUserString(e.target.value)} />
        </div>
        <div className="flex-row justify-content-between input-search_icons">
          {/* <div><i className="fa fa-ellipsis-v" /></div> */}
          {/* <div><i className="fa fa-bell" /></div> */}
        </div>
      </div>
    );
  }
}

ConversationsHeader.propTypes = {};

export default translate(observer(ConversationsHeader));
